<template>
  <div>
    <headCard :type='type' />
    <overview :state="state" />
    <backlog :state="state" :restChart="restChart" />
    <totalOrder :state="state" :type='type' />
    <discount :sevenDataArr="sevenDataArr" />
  </div>
</template>

<script>
import headCard from "../myStatistics/components/headCard";
import overview from "../myStatistics/components/overview";
import backlog from "../myStatistics/components/backlog";
import totalOrder from "../myStatistics/components/totalOrder";
import discount from "../myStatistics/components/discount";
import { getPcCount, countCustomerAnalysis, sevenData} from "@/api/myStatistics";
import {getDataTimeSec} from "@/utils/index"
import i18nMixin from '@/mixins/i18nMixin';

export default {
  name: "enterprise",
  mixins: [i18nMixin],
  data() {
    return {};
  },
  components: {
    headCard,
    overview,
    backlog,
    totalOrder,
    discount,
  },
  props: {
    type: {
      type: Number,
      default: 1,
    },
  },
  created() {
    this.getPcCount();
    this.countCustomerAnalysis();
    this.sevenData();
  },
  data() {
    return {
      state: {},
      restChart: [],
      sevenDataArr:[]
    };
  },
  watch: {
    // 监听语言变化
    currentLanguage() {
      this.updateOrderTypes();
    }
  },
  mounted() {
    this.updateOrderTypes();
  },
  methods: {
    updateOrderTypes() {
      // 更新订单类型文本
      if (this.sevenDataArr && this.sevenDataArr.length > 0) {
        this.sevenDataArr.forEach(item => {
          if (item.city === '商城订单' || item.city === 'Mall Order' || item.city === '商城訂單') {
            item.city = this.$t('dashboard', 'mallOrder');
          } else if (item.city === '个人线下订单' || item.city === 'Personal Offline Order' || item.city === '個人線下訂單') {
            item.city = this.$t('dashboard', 'personalOrder');
          }
        });
      }
    },
    async getPcCount() {
      const result = await getPcCount({ type: this.type });
      if(result.code == 204){
        return
      }
      if(result.data.newCustomerList){
        result.data.newCustomerList.map(val =>{
          val.createTime = getDataTimeSec(val.createTime)
        }) 
      }

      this.state = result.data;
    },
    async countCustomerAnalysis() {
      const result = await countCustomerAnalysis({ type: this.type });
      this.restChart = result.data;
    },
    async sevenData() {
      const result = await sevenData({ type: this.type });
      const { orderList, dealList } = result.data;
      if(orderList.length > 0){
        orderList.map(item =>{
          if(item.amount){
            item.amount = (item.amount/100).toFixed(2)
          }
        })
      }
      if(dealList.length > 0){
        dealList.map(item =>{
          if(item.amount){
            item.amount = (item.amount/100).toFixed(2)
          }
        })
      }
      orderList.map((item) => {
        item.city = this.$t('dashboard', 'mallOrder');
      });
      dealList.map((item) => {
        item.city = this.$t('dashboard', 'personalOrder');
      });
      
      this.sevenDataArr = orderList.concat(dealList);
      console.log(this.sevenDataArr,'1111')
    },
  },
};
</script>

<style lang="scss" scoped>
</style>